import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../lib/api";
import { Button } from "@wondermaps/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/pro-solid-svg-icons/faChartColumn";
import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { CreateOrgDialog } from "../components/superadmin/CreateOrgDialog";
import { SuperadminHeader } from "../components/superadmin/SuperadminHeader";
import type { SuperadminOrganization } from "../components/superadmin/types";

export const Route = createFileRoute("/superadmin/orgs")({
  component: SuperadminOrgsLayout,
});

function SuperadminOrgsLayout() {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  // Fetch organizations for count in header
  const { data } = useQuery({
    queryKey: ["superadmin", "orgs"],
    queryFn: async () => {
      const res = await api.orgs.admin.$get();
      if (!res.ok) throw new Error("Failed to fetch organizations");
      return res.json() as Promise<{ orgs: SuperadminOrganization[] }>;
    },
  });

  const orgs = data?.orgs ?? [];

  return (
    <div className="flex h-screen flex-col bg-background">
      <SuperadminHeader
        title="Organizations"
        subtitle={`${orgs.length} organization${orgs.length !== 1 ? "s" : ""}`}
        actions={
          <>
            <Button size="sm" onClick={() => setCreateDialogOpen(true)}>
              <FontAwesomeIcon icon={faPlus} className="h-4 w-4 mr-1" />
              Create
            </Button>
            <Button variant="outline" size="sm" asChild>
              <Link to="/superadmin/reports">
                <FontAwesomeIcon icon={faChartColumn} className="h-4 w-4 mr-1" />
                Reports
              </Link>
            </Button>
          </>
        }
      />

      <CreateOrgDialog open={createDialogOpen} onOpenChange={setCreateDialogOpen} />

      {/* Content - renders child routes */}
      <main className="flex-1 overflow-auto p-6">
        <div className="container mx-auto max-w-4xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
